import StoreDetails from './StoreDetails'

type StoreFooterProps = {
  /** Classes on the section wrapping `StoreDetails` (spacing from content above). */
  detailsClassName?: string
}

/**
 * Visit us, hours, phone, email/social + copyright — shared across storefront pages.
 * `mt-auto` pins it to the bottom when the page is a full-height flex column with little content.
 */
export default function StoreFooter({ detailsClassName = 'mt-6 sm:mt-12' }: StoreFooterProps) {
  return (
    <div className="mt-auto w-full">
      <section className={detailsClassName}>
        <StoreDetails />
      </section>
      <footer className="mt-2 border-t border-primary-100 pb-4 pt-3 text-center text-xs text-gray-500 sm:pb-5 sm:pt-4 sm:text-sm">
        <p>© {new Date().getFullYear()} Shree Sai Grocery. All rights reserved.</p>
      </footer>
    </div>
  )
}
